import React from 'react';

import i18n from '@client/utils/i18n';
import { GrowthRecipeDoc } from '@ledium/types';
import { ItemList } from '@ledium/ui-common';
import { RecipeTimeline } from '@ledium/ui-recipe-timeline';

type RecipeEditorItem = GrowthRecipeDoc & { id: string };

const RecipeEditorMainMenu = () => {
    function isLocked(recipe: RecipeEditorItem) {
        if (recipe.locked?.reason) {
            if (recipe.locked.reason === 'RUNNING_PROJECT') {
                return i18n('recipe_locked_project') as string;
            }
        }
        return false as const;
    }

    function isLinked(recipe: RecipeEditorItem) {
        if (recipe.linked?.reason === 'LINKED_PROJECT') {
            return i18n('recipe_linked_project') as string;
        }
        return false as const;
    }

    function nameLineExtra(recipe: RecipeEditorItem) {
        return <RecipeTimeline sectionList={recipe.sectionList} />;
    }

    return <ItemList<RecipeEditorItem> isLocked={isLocked} isLinked={isLinked} allowDuplicate={true} nameLineExtra={nameLineExtra} />;
};

export default RecipeEditorMainMenu;
